module.exports = __webpack_public_path__ + "media/images/bnr_special_event_bk-bda24b9c5e6dc10dde41a13f14625482.jpg";